export const calculateMonthlyRateTotal = (monthlyRate: number | null, numMonths: number | null): number | undefined => {
  if (monthlyRate && numMonths) {
    return monthlyRate * numMonths;
  }
  return undefined;
};

export const calculateDayRateTotal = (
  dayRate: number | null,
  dateFrom: string | null,
  dateTo: string | null
): number | undefined => {
  if (dayRate && dateFrom && dateTo) {
    return dayRate * numOfDaysBetween(dateFrom, dateTo);
  }
  return undefined;
};

const numOfDaysBetween = (from: string, to: string): number => {
  const fromMilli = Date.parse(from).valueOf();
  const toMilli = Date.parse(to).valueOf();
  return fromMilli === toMilli
    ? Math.floor((toMilli - fromMilli) / 86400000) + 1 //If from and to date are the same then include the final day
    : Math.floor((toMilli - fromMilli) / 86400000); //Exclude the final day
};
